import { render } from "./px-card.vue?vue&type=template&id=a86231be&scoped=true&ts=true"
import script from "./px-card.vue?vue&type=script&lang=ts"
export * from "./px-card.vue?vue&type=script&lang=ts"

import "./px-card.vue?vue&type=style&index=0&id=a86231be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86231be"]])

export default __exports__